const apiClient = require('@/api/client.js')
import { ToastProgrammatic as Toast } from 'buefy'

export default {

  inviteUserViaPhone(phone_country, phone, callback){

    if (!phone_country){
      return callback(new Error('Invalid phone country'))
    }

    if (!phone){
      return callback(new Error('Invalid phone'))
    }

    let params = {
      phone,
      phone_country
    }

    return apiClient.post('/user/invite', params, callback);
  }

}



// WEBPACK FOOTER //
// ./src/components/user/service.js